/*
* PromoCTA 
* GNN Solutions
* https://gnnsolutions.co.uk
* V1 
*/

$(document).ready(function($) {

    // Adding hidden class to PromoCTA on CLOSE CLICK
    $(".promocta__close").on("click", function() {
        $(".promocta").addClass("hidden");
    });   

});